import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "flex items-center" };
const _hoisted_2 = { class: "capitalize text-primary font-bold overflow-ellipsis overflow-hidden whitespace-nowrap" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", { class: "fas fa-crown text-xs ml-2" }, null, -1);
const _hoisted_4 = { class: "flex flex-row h-full overflow-hidden px-2" };
const _hoisted_5 = {
    key: 0,
    class: "w-full md:w-1/2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_admin_vault_overview = _resolveComponent("admin-vault-overview");
    const _component_workspace_details = _resolveComponent("workspace-details");
    const _component_tab_layout = _resolveComponent("tab-layout");
    const _component_create_workspace_modal = _resolveComponent("create-workspace-modal");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_tab_layout, null, {
            title: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('vault.vaults')), 1),
                    _hoisted_3
                ])
            ]),
            content: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_admin_vault_overview, {
                        vaults: _ctx.vaults,
                        "onUpdate:vaults": _cache[0] || (_cache[0] = ($event) => ((_ctx.vaults) = $event)),
                        onSelectedItem: _ctx.updateSideBar,
                        class: _normalizeClass({ 'hidden md:block': !!_ctx.selectedWorkspace }),
                        onShowCreateWorkspace: _cache[1] || (_cache[1] = ($event) => (_ctx.showCreateWorkspace = true)),
                        onOpenItem: _ctx.openWorkSpaceOverview
                    }, null, 8, ["vaults", "onSelectedItem", "class", "onOpenItem"]),
                    (_ctx.selectedWorkspace)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_openBlock(), _createBlock(_component_workspace_details, {
                                onOpenVault: _ctx.openWorkSpaceOverview,
                                selectedWorkspace: _ctx.selectedWorkspace,
                                "onUpdate:selectedWorkspace": _cache[2] || (_cache[2] = ($event) => ((_ctx.selectedWorkspace) = $event)),
                                key: _ctx.selectedWorkspace.id,
                                onCollapseSidebar: _cache[3] || (_cache[3] = ($event) => (_ctx.selectedWorkspace = undefined)),
                                onUpdateWorkspace: _ctx.handleUpdateVault
                            }, null, 8, ["onOpenVault", "selectedWorkspace", "onUpdateWorkspace"]))
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.$t('user.users')) + " ", 1)
            ]),
            _: 1
        }),
        _createVNode(_component_create_workspace_modal, {
            show: _ctx.showCreateWorkspace,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event) => ((_ctx.showCreateWorkspace) = $event))
        }, null, 8, ["show"])
    ], 64));
}
